import { flexRender } from "@tanstack/react-table"

import { useTableContext } from "#Contexts/TableContext"
import cn from "#Utils/cn"

const Rows = ({ narrow = false, isHighlighted, onClick }) => {
  const { table, error, dataSize } = useTableContext()

  if (error) return null
  if (dataSize === 0) return null

  const { renderSubComponent } = table.options.meta

  return (
    <tbody>
      {table.getRowModel().rows.map((row) => (
        <React.Fragment key={row.id}>
          <tr
            onClick={() => {
              if (typeof onClick === "function") {
                onClick(row.original)
              }
            }}
            className={cn({
              "bg-surface-highlight":
                typeof isHighlighted === "function" && isHighlighted(row.original),
              "cursor-pointer": typeof onClick === "function",
            })}
          >
            {row.getVisibleCells().map((cell) => {
              return (
                <td
                  key={cell.id}
                  className={cn(
                    "c-table__td",
                    {
                      "c-table__td--narrow": narrow,
                      "text-center": cell.column.id === "selection",
                    },
                    cell.column.columnDef.meta?.className,
                  )}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </td>
              )
            })}
          </tr>
          {row.getIsExpanded() && renderSubComponent && (
            <tr>
              <td colSpan={row.getVisibleCells().length} className="c-table__td">
                {renderSubComponent({ row })}
              </td>
            </tr>
          )}
        </React.Fragment>
      ))}
    </tbody>
  )
}

Rows.propTypes = {
  narrow: PropTypes.bool,
  isHighlighted: PropTypes.func,
  onClick: PropTypes.func,
}

export default Rows
